import React from 'react'

import CheckboxComponent from '../CommonComponents/CheckboxComponent'
import CustomTooltip from '../CommonComponents/CustomTooltip'

const CheckInput = ({ label, field, inputField, suffix = null, settings, tooltip = null, onChange }) => {
  const validate = () => {
    if (settings[inputField] === ''
      || isNaN(settings[inputField])
      || parseFloat(settings[inputField]) < 0) {
      onChange(inputField, 0)
    }
  }

  return (
    <div className="field-wrapper">
      <div className="field-name">
        { label }
        {
          tooltip !== null && (
            <CustomTooltip>
              <p>{ tooltip }</p>
            </CustomTooltip>
          )
        }
      </div>
      <div className="check-input-container">
        <CheckboxComponent
          checked={settings[field]}
          onChange={(checked) => { onChange(field, checked) }}
        />
        <input
          type="number"
          min="0"
          disabled={!settings[field]}
          value={settings[inputField]}
          onChange={(event) => { onChange(inputField, event.target.value) }}
          onBlur={validate}
        />
        {
          suffix !== '' && <span className="input-desc">{ suffix }</span>
        }
      </div>
    </div>
  )
}

export default CheckInput
